<template>
	<div class="zh-classroom-visits2">
		<div class="zh-h5">
			<span>
				<router-link to="/home" tag="a">首页</router-link> >
				<router-link to="/affairs/inspection/classroom-visits" tag="a">课堂直播</router-link>
				>
				<span>直播详情</span>
			</span>
		</div>
		<div class="tour-course">
			<div class="tour-course-menu">
				<ul>
					<li class="i_vp clear">
						<a @click="back">返回</a>
					</li>
					<li class="i_vp clear">
						<span>设备名称：</span>
						<span>{{liveData.deviceName}}</span>
					</li>
					<li class="i_vp clear">
						<span>校园分区：</span>
						<span>{{liveData.partition}}</span>
					</li>
					<li class="i_vp clear">
						<span>设备说明：</span>
						<span>{{liveData.deviceDes}}</span>
					</li>
					<li class="i_vp clear">
						<div>
							<span>设备状态：</span>
							<span>{{liveData.deviceStatus}}</span>
						</div>
						<div>
							<span>课程名称：</span>
							<span :title="liveData.coursename">{{liveData.coursename}}</span>
						</div>
						<div>
							<span>主讲人：</span>
							<span>{{liveData.userName}}</span>
						</div>
						<div>
							<span>直播时间：</span>
							<span>{{liveData.time}}</span>
						</div>
						<div>
							<span>课程地址：</span>
							<span style="word-wrap: break-word;word-break: break-all;">{{liveData.liveUrl}}</span>
						</div>
					</li>
				</ul>
			</div>

			<div class="course-video">
				<div class="course-mb">
					<div class="video-py"  id="newPlayDom">
                        <video
                            id="videoRoomPlayer"
                            ref="videoRoomPlayer"
                            class="video-js vjs-big-play-centered vjs-fluid"
                            width="100%"
                            height="50%">
                        </video>
						<!-- <video-player class="video-player vjs-custom-skin play-no" id="videoPlayer" style="width:100%;height: 100%" ref="videoPlayer" :playsinline="true" :options="videoOptions"></video-player> -->
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import "videojs-flash";
import './../../../assets/js/zh-CN'

export default {
    data() {
        return {
            player: null, // 播放器
            loading: {
                status: false
            },
            liveData: {
                deviceName: "",
                partition: "",
                deviceDes: "------",
                deviceStatus: "",
                coursename: "------",
                time: "",
                userName: "",
                liveUrl: "------"
            },
                        playerOptions: {
                    loop: false, // true -- 视频一结束就重新开始
                    controls: true,
                    autoplay: false, // true--浏览器准备好时开始回放
                    height: '360',
                    poster: "", // 封面地址
                    language: 'zh-CN',
                    techOrder: ['flash'],
                    sources: [{
                        type: "rtmp/mp4", // 类型
                        src: 'banan' // 视频播放路径
                    }],
                    controlBar: {
                        children: [
                            {name: 'playToggle'}, // 播放按钮
                            {name: 'currentTimeDisplay'}, // 当前已播放时间
                            {name: 'progressControl'}, // 播放进度条
                            {name: 'durationDisplay'}, // 总时间
                            {
                                name: 'volumePanel', // 音量控制
                                inline: false, // 不使用水平方式
                            },
                            {name: 'FullscreenToggle'} // 全屏
                        ]
                    },
                },
            // videoOptions: {
            //     loop: false,
            //     height: "360",
            //     sources: [
            //         {
            //             type: "rtmp/mp4",
            //             src: "blala"
            //         }
            //     ],
            //     techOrder: ["flash"],
            //     autoplay: false,
            //     controls: true,
            //     poster: "",
            //     controlBar: {
            //         timeDivider: true,
            //         durationDisplay: true,
            //         remainingTimeDisplay: false,
            //         fullscreenToggle: true //全屏按钮
            //     }
            // },
            liveUrl: ""
        };
    },
    created() {
        this.getLiveUrl();
    },
    mounted(){
        this.getLiveInfo();
    },
    beforeDestroy() {
        // this.videoOptions = null;
        // this.$refs.videoPlayer.player.cache_ = null;
        // this.$refs.videoPlayer.player.off();
        // this.$refs.videoPlayer.dispose();
        // this.$refs.videoPlayer = null;
                    this.player && this.player.dispose();
    },
    methods: {
        getLiveUrl() {
            let success = data => {
                this.liveUrl = data.data;
            };
            this.$ajax.get("api/recorder/live_url", {
                func: { success: success }
            });
        },
        getLiveInfo() {
            this.loading.status = true;
            let success = data => {
                this.loading.status = false;
                if (!is_empty(data.data)) {
                    this.liveData.deviceName = data.data.recorder_name
                        ? data.data.recorder_name
                        : "-";
                    this.liveData.partition = data.data.class_name
                        ? data.data.class_name
                        : "-";
                    this.liveData.deviceDes = data.data.comment
                        ? data.data.comment
                        : "-";
                    this.liveData.deviceStatus =
                        data.data.recorder_status === 0 ? "空闲中" : "上课中";
                    this.liveData.coursename = data.data.coursename
                        ? data.data.coursename
                        : "-";
                    this.liveData.time =
                        (data.data.starttime ? data.data.starttime : "") +
                        "-" +
                        (data.data.endtime ? data.data.endtime : "");
                    this.liveData.userName = data.data.username
                        ? data.data.username
                        : "-";
                    this.liveData.liveUrl = data.data.recorder_status === 0 ? '' : this.BASE_URL + '/home/liveRoom?id=' + data.data.live_id

                }
                this.videoCommonView( this.liveData.id )
            };

            let fail = data => {
                this.loading.status = false;
                this.$message.error(data.msg);
            };

            //执行请求，并将回调方法变成config成员以便鉴权过期可以执行
            this.$ajax.get("api/recorder/get_live_info", {
                params: { id: this.$route.query.id },
                func: { success: success, fail: fail }
            });
        },
        videoCommonView(){
            var url = this.liveUrl + this.$route.query.id;
            // this.$refs.videoPlayer.player.src({ type : "rtmp/mp4", src : url }) ;
            // this.$refs.videoPlayer.player.play();
                   let self = this;
                this.player && this.player.dispose();
                let videoRoomPlayer = document.getElementById('newPlayDom');
                videoRoomPlayer.innerHTML = '<video id="videoRoomPlayer" class="video-js vjs-big-play-centered vjs-fluid" width="100%" height="100%"> </video>'
                this.playerOptions.sources[0].src= url;

                this.player = this.$videojs('videoRoomPlayer', this.playerOptions, function onPlayerReady() {})
        },
        back() {
            this.$router.go(-1);
        }
    }
};
</script>

<style lang="scss">
@import url('../../../assets/css/video.css');
.zh-classroom-visits2 {
    // .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    //     left: 22px !important;
    // }
    .videoRoomPlayer-dimensions.vjs-fluid {
        padding-top: 49%;
    }

    .vjs-control-bar .vjs-play-control.vjs-button .vjs-icon-placeholder::before{
        display: flex;
        justify-content: center;
    }

    .tour-course {
        background: #effaff;
        position: absolute;
        width: 100%;
        height: calc(100% - 61px);
        top: 61px;
        left: 0;
        font-size: 0;
        overflow: hidden;
        > div {
            text-align: left;
            text-align-last: initial;
            height: 100%;
            display: inline-block;
            vertical-align: top;
        }
    }

    .videoPN {
        width: 100%;
        height: 100%;
    }
    .video-js {
        width: 100%;
        height: 100%;
    }

    .tour-course-menu {
        background: #dff3f9;
        width: 260px;
        overflow: hidden;

        .el-menu-item.is-active {
            color: #ffffff;
        }

        ul {
            height: 100%;

            .i_vp {
                position: relative;
                padding: 22px 10px 22px 25px;
                overflow-wrap: break-word;
                word-break: break-all;
                font-size: 12px;
                line-height: 20px;
                border-bottom: 1px solid #d1e5eb;
            }
            li:first-child {
                padding-left: 0;
                font-size: 14px;
                cursor: pointer;

                a {
                    display: inline-block;
                    padding-left: 45px;
                    width: 100%;
                    height: 100%;
                }
            }
            li:first-child:before {
                display: inline-block;
                content: " ";
                height: 10px;
                width: 10px;
                border-width: 0 0 2px 2px;
                border-color: #232323;
                border-style: solid;
                transform: matrix(0.71, 0.71, -0.71, 0.71, 0, 0);
                position: absolute;
                top: 50%;
                left: 29px;
                margin-top: -5px;
            }

            li:last-child {
                div {
                    margin: 20px 0;

                    span:first-child {
                        display: inline-block;
                        width: 60px;
                        text-align: right;
                    }
                }
            }
        }
    }

    .course-video {
        width: calc(100% - 260px);
    }

    .course-mb {
        height: 90%;
        width: 100%;
        margin: 3% auto 0;
        position: relative;

        > i {
            font-size: 30px;
            cursor: pointer;
            position: absolute;
            top: 48%;
            &:nth-of-type(1) {
                left: 0;
            }
            &:nth-of-type(2) {
                right: 0;
            }
            &:hover {
                color: #409eff;
            }
        }
        > div {
            width: 95%;
            height: 100%;
            // text-align: justify;
            // text-align-last: justify;
            background: #ccc;
            margin: auto;
        }
    }

    .play-no {
        .i_vidioLk {
            display: none;
        }
        .i_vidioI {
            display: none;
        }
        .vjs-custom-skin > .video-js .vjs-big-play-button {
            text-align: center;
        }
    }

    .i_equipment {
        border-bottom: 1px solid #c4e2eb;
        font-size: 14px;
        > h2,
        > a {
            font-size: 14px;
            height: 54px;
            line-height: 54px;
            padding: 0 20px;
        }
        > a {
            > i {
                background: none;
                margin-right: 10px;
            }
        }
    }

    // .video-js .vjs-big-play-button .vjs-icon-placeholder:before {
    //     left: 36px;
    // }

    // .vjs-custom-skin > .video-js .vjs-control-bar .vjs-time-control {
    //     display: inline-block;
    //     width: auto;
    //     overflow: hidden;
    //     text-align: center;
    // }
}
</style>